import { defineMessages } from 'react-intl';

const scope = 'app.widgets.BusinessAnalysis.detailedView';

const headerMessages = defineMessages({
    closeButtonTooltip: {
        id: `${scope}.header.closeButtonTooltip`,
        defaultMessage: 'Close detailed view',
    },
    showNonGuaranteed: {
        id: `${scope}.header.showNonGuaranteed`,
        defaultMessage: 'Show unguaranteed',
    },
});

const footerMessages = defineMessages({
    export: {
        id: `${scope}.footer.exportToCSV`,
        defaultMessage: 'Export to CSV',
    },
});

/**
 * Message for headers in table & CSV
 */
const tableMessages = defineMessages({
    roomsHeader: {
        id: `${scope}.table.header.rooms.guaranteed`,
        defaultMessage: 'Rooms',
    },
    nonGuaranteedRoomsHeader: {
        id: `${scope}.table.header.rooms.nonGuaranteed`,
        defaultMessage: 'Rooms (Unguar.)',
    },
    revenueHeader: {
        id: `${scope}.table.header.revenue.guaranteed`,
        defaultMessage: 'Revenue',
    },
    nonGuaranteedRevenueHeader: {
        id: `${scope}.table.header.revenue.nonGuaranteed`,
        defaultMessage: 'Revenue (Unguar.)',
    },
    adrHeader: {
        id: `${scope}.table.header.adr.guaranteed`,
        defaultMessage: 'ADR',
    },
    nonGuaranteedAdrHeader: {
        id: `${scope}.table.header.adr.nonGuaranteed`,
        defaultMessage: 'ADR (Unguar.)',
    },
    revParHeader: {
        id: `${scope}.table.header.revPar.guaranteed`,
        defaultMessage: 'RevPAR',
    },
    nonGuaranteedRevParHeader: {
        id: `${scope}.table.header.revPar.nonGuaranteed`,
        defaultMessage: 'RevPAR (Unguar.)',
    },
    occupancyHeader: {
        id: `${scope}.table.header.occupancy.guaranteed`,
        defaultMessage: 'Occupancy',
    },
    nonGuaranteedOccupancyHeader: {
        id: `${scope}.table.header.occupancy.nonGuaranteed`,
        defaultMessage: 'Occupancy (Unguar.)',
    },
});

export default {
    header: headerMessages,
    footer: footerMessages,
    table: tableMessages,
};
